import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsAmazonMCF() {
  return (
    <IntegrationDocTemplate
      title="Amazon Multi-Channel Fulfillment (MCF)"
      category="Warehousing · 3PL"
      status="live"
      summary="Use Amazon's fulfillment network for orders from your Shopify, BigCommerce, or other non-Amazon channels. Average 1.9-day click-to-door. Preferred Pricing for eligible sellers (Jan 2026)."
      prerequisites={[
        'Amazon Seller account with FBA enabled.',
        'Inventory sent to Amazon FCs (via inbound shipment).',
        'SP-API credentials (same as Amazon Seller Central integration).',
      ]}
      connectSteps={[
        'Text us "Amazon MCF" with your phone number.',
        'If you already have SP-API connected, MCF activates automatically.',
        'Choose which CI channels (Shopify orders, BigCommerce orders) route through MCF.',
        'Optional: enable unbranded (blank) box shipping for white-label.',
      ]}
      syncedData={[
        { type: 'Fulfillment orders', detail: 'CI → MCF: create_fulfillment_order with shipping speed (standard/expedited/priority)' },
        { type: 'Tracking', detail: 'Real-time package tracking via SP-API' },
        { type: 'Inventory', detail: 'FBA inventory shared with MCF — same pool' },
        { type: 'Inbound shipments', detail: 'Send inventory to Amazon FCs' },
      ]}
      agents={[
        { id: 'order_router_agent', name: 'order_router_agent', role: 'Routes orders to MCF when faster/cheaper than other 3PLs' },
      ]}
      troubleshooting={[
        { question: 'MCF order failed', answer: 'Most common: insufficient FBA inventory in the target FC. We auto-fallback to next-best 3PL based on your routing rules.' },
        { question: 'Preferred Pricing not applied', answer: 'Jan 2026 update — must enroll separately in Seller Central. Once enrolled, MCF fees drop ~15-25% + FBA credits.' },
      ]}
      supportLink="/contact"
    />
  );
}
